export default "__VITE_ASSET__rLrN9Kcl__"